import React from "react";
import {
  Box,
  Card,
  Grid,
  CardContent,
  Typography,
  Skeleton,
} from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { useParams } from "react-router-dom";
import ReactApexChart from "react-apexcharts";

export default function CompanyDirectors() {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [boys, setBoys] = React.useState(0);

  let params = useParams();
  const id = params.companyId;

  async function fetchDirectors({ id }) {
    setLoading(true);
    const q = query(
      collection(db, "companies-directors"),
      where("company-id", "==", id)
    );

    const allDocs = [];
    let male = 0;
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      if (doc.data()["gender"] === "Male") {
        male += 1;
      }
    });
    setData(allDocs);
    setBoys(male);
    setLoading(false);
  }

  React.useEffect(() => {
    fetchDirectors({ id });
  }, [id]);

  const list = Array.from({ length: 16 }, (v, k) => k + 1);

  function titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
    }
    return str.join(' ');
  }

  const options = {
    theme: {
      mode: "dark",
    },
    chart: {
      height: 350,
      type: "radialBar",
      // offsetY: -10,
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: "20px",
            color: "#008000",
            offsetY: 120,
          },
          value: {
            offsetY: 76,
            fontSize: "22px",
            formatter: function (val) {
              return val + "%";
            },
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        // shade: "dark",
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
      },
    },
    stroke: {
      dashArray: 2,
    },
    labels: ["Male"],
  };

  return loading ? (
    <Box>
      <Grid container spacing={2}>
        {list.map((index) => {
          return (
            <Grid item xs={12} md={6} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h5">
                    <Skeleton width="50%" sx={{ bgcolor: "white" }} />
                  </Typography>
                  <Typography variant="subtitle2">
                    <Skeleton sx={{ bgcolor: "white" }} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  ) : data.length > 0 ? (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ReactApexChart
            series={[Math.round((boys / data.length) * 100)]}
            options={options}
            type="radialBar"
            height={350}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          margin: "10px",
        }}
      />
      <Grid container spacing={2}>
        {data.map((person) => {
          return (
            <Grid item xs={12} md={6} key={person["name"]}>
              <Card>
                <CardContent>
                  <Typography variant="h5">{titleCase(person["name"])}</Typography>
                  <Typography variant="subtitle2">{person["role"]}</Typography>
                  <Typography variant="subtitle2">
                    {person["gender"]}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  ) : (
    <>
      <Typography variant="h5">No Data Available</Typography>
    </>
  );
}
